import { Nullable } from "primereact/ts-helpers";
import { useEffect, useState } from "react";
import { ApiLotteryData, UpdateLotteryForm } from "../model/adminLottery.model";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { updateLotteryService } from "../services/adminLottery.service";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { ToastControlBackendModel } from "../../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";

interface Props {
  getAllLotteryData: () => void;
  setDialogEditLottery: (data: boolean) => void;
  dataLottery: ApiLotteryData;
  setMessageBackend: (value: ToastControlBackendModel) => void;
}

function FormEditLottery({
  getAllLotteryData,
  setDialogEditLottery,
  dataLottery,
  setMessageBackend,
}: Props): JSX.Element {
  const dateDb = new Date(dataLottery.dateLottery);
  const [descriptionLottery, setDescriptionLottery] = useState<string>(dataLottery.descriptionLottery);
  const [rewardLottery, setRewardLottery] = useState<number>(dataLottery.rewardLottery);
  const [dateEndLottery, setDateEndLottery] = useState<Nullable<Date>>(dateDb);
  const [validateForm, setValidateForm] = useState(false);
  const [stateLottery, setStateLottery] = useState<boolean>(dataLottery.stateLottery);
  const [numberLottery, setNumberLottery] = useState<number | null>(dataLottery.numberLottery);

  const onSubmit = async () => {
    setValidateForm(false);
    try {
      const data: UpdateLotteryForm = {
        descriptionLottery,
        rewardLottery,
        dateEndLottery: dateEndLottery
          ? dateEndLottery.toISOString().split("T")[0]
          : null,
        stateLottery,
        idLottery: dataLottery.idLottery,
        numberLottery: numberLottery ? numberLottery : null,
      };
      const response = await updateLotteryService(data);
      if (response.statusCode < 299) {
        getAllLotteryData();
        setDialogEditLottery(false);
        setMessageBackend({
          detailValue: "Sorteo editado con éxito",
          severityValue: "success",
          lifeValue: 3000,
          validateShowMessage: true,
        });
      }
    } catch (error) {
      setMessageBackend({
        detailValue: "Error al editar el sorteo",
        severityValue: "error",
        lifeValue: 3000,
        validateShowMessage: true,
      });
    } finally {
      setValidateForm(true);
    }
  };

  useEffect(() => {
    if (descriptionLottery !== "" && rewardLottery !== 0 && dateEndLottery !== null) {
      setValidateForm(true);
    }
  }, [descriptionLottery, rewardLottery, dateEndLottery]);

  const inputStyle: React.CSSProperties = {
    backgroundColor: "#ffffff",
    color: "#333333",
    border: "1px solid #cbd5e1",
    borderRadius: "6px",
    padding: "0.75rem 1rem",
    width: "100%",
  };

  const labelStyle: React.CSSProperties = {
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#475569",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "0.25rem"
  };

  return (
    <div className="w-full py-1">
      <style>{`
        /* Placeholders */
        .edit-lottery-form .p-inputtext::placeholder {
          color: #9ca3af !important;
          opacity: 1 !important;
        }

        /* Focus */
        .edit-lottery-form .p-inputtext:focus {
          outline: none !important;
          border-color: #00A86B !important;
          box-shadow: 0 0 0 2px rgba(0,168,107,0.15) !important;
        }

        /* Botón icono calendario */
        .edit-lottery-form .p-calendar .p-datepicker-trigger {
          background: #f1f5f9 !important;
          border: 1px solid #cbd5e1 !important;
          border-left: none !important;
          color: #64748b !important;
        }
        .edit-lottery-form .p-calendar .p-datepicker-trigger:hover {
          background: #e2e8f0 !important;
        }

        /* Switch — quitar azul */
        .edit-lottery-form .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
          background: #00A86B !important;
        }
        .edit-lottery-form .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
          background: #ffffff !important;
        }
        .edit-lottery-form .p-inputswitch .p-inputswitch-slider {
          background: #e5e7eb !important;
        }

        /* Calendario blanco */
        .p-datepicker {
          background: #ffffff !important;
          border: 1px solid #e5e7eb !important;
          border-radius: 8px !important;
          box-shadow: 0 4px 16px rgba(0,0,0,0.08) !important;
        }
      `}</style>

      <div className="edit-lottery-form flex flex-column gap-4 w-full">

        {/* Usamos la Grid nativa de PrimeFlex para evitar que se aprieten y se tuerzan */}
        <div className="grid">

          {/* Descripción */}
          <div className="col-12 md:col-6 flex flex-column mb-2">
            <label style={labelStyle}>Descripción</label>
            <InputText
              value={descriptionLottery}
              autoFocus
              style={inputStyle}
              type="text"
              placeholder="Descripción del sorteo"
              id="descriptionLottery"
              onChange={(e) => setDescriptionLottery(e.target.value)}
            />
          </div>

          {/* Número ganador */}
          <div className="col-12 md:col-6 flex flex-column mb-2">
            <label style={labelStyle}>Número ganador</label>
            <InputText
              value={numberLottery !== null ? String(numberLottery) : ""}
              style={inputStyle}
              type="number"
              placeholder="Número ganador"
              id="numberLottery"
              onChange={(e) => setNumberLottery(e.target.value !== "" ? +e.target.value : null)}
            />
          </div>

          {/* Ganancia */}
          <div className="col-12 md:col-6 flex flex-column mb-2">
            <label style={labelStyle}>Ganancia</label>
            <InputText
              value={String(rewardLottery)}
              style={inputStyle}
              type="number"
              maxLength={10}
              id="rewardLottery"
              placeholder="Ganancia"
              onChange={(e) => setRewardLottery(Number(e.target.value))}
            />
          </div>

          {/* Fecha Finaliza */}
          <div className="col-12 md:col-6 flex flex-column mb-2">
            <label style={labelStyle}>Fecha finaliza</label>
            <Calendar
              id="dateEndLottery"
              value={dateEndLottery}
              onChange={(e) => setDateEndLottery(e.value)}
              dateFormat="yy/mm/dd"
              placeholder="Fecha de sorteo"
              className="w-full"
              inputStyle={inputStyle}
              style={{ width: "100%" }}
              showIcon
            />
          </div>

        </div>

        {/* Fila inferior: Switch de Estado y Botón de Acción */}
        <div className="flex align-items-center justify-content-between pt-2 border-top-1 surface-border">

          {/* Estado */}
          <div className="flex align-items-center gap-3">
            <InputSwitch
              checked={stateLottery}
              onChange={(e) => setStateLottery(e.value)}
            />
            <span
              style={{
                fontSize: "0.85rem",
                fontWeight: 600,
                color: stateLottery ? "#00A86B" : "#ef4444",
                backgroundColor: stateLottery ? "#e6f7f1" : "#fef2f2",
                padding: "0.25rem 0.75rem",
                borderRadius: "999px",
              }}
            >
              {stateLottery ? "Activo" : "Inactivo"}
            </span>
          </div>

          {/* Botón Guardar Cambios */}
          <Button
            label="Guardar cambios"
            disabled={!validateForm}
            onClick={onSubmit}
            style={{
              backgroundColor: validateForm ? "#00A86B" : "#cbd5e1",
              borderColor: validateForm ? "#00A86B" : "#cbd5e1",
              color: "#ffffff",
              fontWeight: 600,
              borderRadius: "8px",
              padding: "0.65rem 1.75rem",
            }}
          />
        </div>

      </div>
    </div>
  );
}

export default FormEditLottery;